/**
 * Single source for user-facing copy that must stay in sync with Flutter.
 *
 * Drift here used to bite us — three places already had three different
 * spellings of the empty-slot message before this constant landed
 * (verbatim, truncated, and a third missing the Overbooking hint).
 *
 * If you change a string here, also change the matching Flutter widget
 * line and update the comment so the next reviewer can verify parity.
 */

/**
 * Empty-slot empty-state message — Flutter
 * `date_time_widget.dart:131`,
 * `provider_selection_widget.dart:394`,
 * `select_doctor_widget.dart:378`.
 */
export const NO_SLOT_AVAILABILITY_MESSAGE =
  "No availability on this day. You can enable 'Overbooking' in Settings to double-book.";
